import {Outlet, useNavigate} from 'react-router-dom';
import { useEffect } from 'react';

import './Layout.css';


function Layout() {
    //top level layout of app
    
    const navigate = useNavigate();

    useEffect(() => {
        //redirect to /notes by default
        if (window.location.pathname === "/")
        navigate('/notes');
    });
    
    const toggleNoteNav = () => {
        //toggles note navigation sidebar
        const nav = document.getElementById("note-navigator");
        if (nav.style.display == "none") {
            nav.style.display = "flex";
        }
        else {
            nav.style.display = "none";
        }    
        
    }

    return (
        <div className = "page-content">
            
            <div className='navbar'>
                <button id='sidebar-toggle' onClick={toggleNoteNav}>&#9776;</button>
                <div className='app-title'>
                    <h1>Lotion</h1>
                    <h4>Like Notion, but worse</h4>
                </div>
                <div className='empty-div'></div>
            </div>

            <div className='outlet-content'>
                <Outlet />                
            </div>

        </div>
        );
}

export default Layout;